import type { SVGProps } from "react";

export default function DataFolderIcon(
  props: Readonly<SVGProps<SVGSVGElement>>,
) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15.0002 8.3335H10.8335"
        stroke="currentColor"
        strokeWidth="1.25528"
        strokeLinecap="round"
      />
      <path
        d="M8.3335 2.49951H13.7502C14.1372 2.49951 14.3307 2.49951 14.4932 2.5209C15.615 2.6686 16.4977 3.55136 16.6454 4.67319C16.6668 4.83565 16.6668 5.02916 16.6668 5.41618"
        stroke="currentColor"
        strokeWidth="1.25528"
      />
      <path
        d="M1.6665 5.79178C1.6665 5.05634 1.6665 4.68862 1.7243 4.38232C1.9787 3.03392 3.03343 1.97919 4.38183 1.72478C4.68813 1.66699 5.05585 1.66699 5.7913 1.66699C6.11352 1.66699 6.27464 1.66699 6.42948 1.68148C7.09705 1.7439 7.73027 2.00619 8.24645 2.43408C8.36617 2.53333 8.48009 2.64727 8.70792 2.87512L9.1665 3.33366C9.84634 4.01348 10.1863 4.35338 10.5933 4.57985C10.8168 4.70425 11.0541 4.80249 11.3002 4.87264C11.7481 5.00033 12.2288 5.00033 13.1902 5.00033H13.5016C15.6953 5.00033 16.792 5.00033 17.505 5.64154C17.5706 5.70053 17.633 5.76294 17.6919 5.82852C18.3332 6.54145 18.3332 7.63828 18.3332 9.83191V11.667C18.3332 14.8097 18.3332 16.3811 17.3568 17.3573C16.3806 18.3337 14.8092 18.3337 11.6665 18.3337H8.33317C5.19047 18.3337 3.61913 18.3337 2.64281 17.3573C1.6665 16.3811 1.6665 14.8097 1.6665 11.667V5.79178Z"
        stroke="currentColor"
        strokeWidth="1.25528"
      />
    </svg>
  );
}
